<template>
  <div>
    <div v-if="title">
      <van-cell class="title_cell" :title="title" :icon="icon" :style="titleStyle"/>
    </div>
    <van-grid :column-num="grid_column_num" :border="false" :square="square" :gutter="gutter">
      <van-grid-item v-for="(item, index) in grid_list" :key="index" @click="clickItem(item.props)">
        <!--                <div v-if="$common.isShowComponent(item)">-->
        <!--                    -->
        <!--                </div>-->
        <AnimeScale :config="item.props">
          <div v-if="item.props && item.props.text" style="padding-top: 8px">
            <div slot="icon" style="text-align: center">
              <!--                        <van-icon v-if="item.img" :name="item.img" size="50" style="line-height: 1px" :radius="radius ? 5 : 0"></van-icon>-->
              <Wp_image
                  v-if="item.props.img"
                  :url="item.props.img"
                  :radius="radius"
                  :round="round"
                  :img-gray="imgGray"
                  :width="img_width"

              ></Wp_image>
              <!--                        <van-icon :name="item.props.img" size="50"/>-->
            </div>

            <div
                slot="text"
                :style="item.props.title_style ? item.props.title_style : {color: item.props.text_color ? item.props.text_color : '', textAlign: 'center'}"
            >{{ item.props.text }}
            </div>
          </div>
          <div v-else>
            <div v-if="item.props && item.props.img" slot="default">
              <Wp_image
                  v-if="item.props.img"
                  :url="item.props.img"
                  :radius="radius"
                  :round="round"
                  :img-gray="imgGray"
              ></Wp_image>
            </div>
          </div>
        </AnimeScale>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
import Wp_image from './Wp_image'
import AnimeScale from '../anime/AnimeScale'

export default {
  name: 'Wp_grid',
  components: { AnimeScale, Wp_image },
  props: {
    list: { type: Array }, //list = [{"img": "img_url", ...},{}] // [{component: "", id: "", props:{}}]
    columnNum: { type: Number, default: 4 },
    round: { type: Boolean, default: false },
    radius: { type: Number, default: 0 },
    square: { type: Boolean, default: true },
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    titleStyle: { type: String, default: '' },
    imgGray: { type: Boolean, default: false }
  },
  data () {
    return {
      grid_list: [],
      grid_column_num: 4,
      img_width: '72',
      gutter: 0,
    }
  },

  created () {
    this.initGridData()
  },

  methods: {
    clickItem (item) {
      this.$emit('clickItem', item)
    },

    initGridData () {
      if (this.list) {
        for (let i = 0; i < this.list.length; i++) {
          let item = this.list[i]

          if (this.$common.isShowComponent(item)) {
            // if(this.$config.project !== 'mini' || item.props.text !== '淘宝'){
            //     this.grid_list.push(item);
            // }
            this.grid_list.push(item)
          }
        }

        if (this.columnNum <= this.grid_list.length) {
          this.grid_column_num = this.columnNum
        } else {
          this.grid_column_num = this.grid_list.length
          // this.img_width = '60';
        }

      }
    },
  }
}
</script>

<style scoped>
/deep/ .van-grid-item .van-grid-item__content {
  background-color: rgba(255, 0, 255, 0);
  padding: 5px;
}

.title_cell {
  padding: 0px 1px;
  background-color: rgba(0, 0, 0, 0);
}
</style>